/**
 * **A port of `legacy/frontend/src/screens/sermonEdit.ts`, whole but for its `:1`.** F-025 T4:
 * `edit()`, one edit of the rota of sermons with its refusal turned into something to draw — the
 * rota as it now is, the refusal and the place it belongs, and whether the sheet it was made in
 * may close.
 *
 * Their `:1` is one import that mixes the value `ApiError` with the type `SermonRota`. The type is
 * a server shape, so here it comes from `@contracts/index` (ADR-0011), and the value stays on
 * `../api` — `format.ts`'s split, two lines for their one. Their `:2` to the end is theirs byte for
 * byte, and `scripts/ported-partial.txt` holds that region.
 */

import type { SermonRota } from '@contracts/index';
import { ApiError } from '../api';

/** A refusal and where it belongs: `screen`, or one date's session id. */
export type Refusal = { at: string; text: string };

/** What one edit of the rota came to. */
export type Answer = {
  /** The rota as it now is, and null when nothing changed. */
  rota: SermonRota | null;
  /** Drawn where the tap was; null once something went through. */
  refusal: Refusal | null;
  /** Whether what the tap was made in may now close. */
  settled: boolean;
};

/**
 * One edit of the rota, with its refusal turned into something to draw.
 *
 * `settled` is the whole reason this is a function rather than a try/catch
 * inside the screen. A refusal of an action is drawn where the tap was and
 * stays there, and for an assignment that place is the sheet «Кого поставить»:
 * the tile in «Дальше» behind it draws no refusal at all. A sheet closed over
 * a refusal therefore closes over the only copy of it - which is what happened
 * until 2026-08-31, when an assignment the server refused shut the sheet and
 * left nothing on the screen to say so.
 */
export async function edit(at: string, action: () => Promise<SermonRota>): Promise<Answer> {
  try {
    return { rota: await action(), refusal: null, settled: true };
  } catch (error) {
    return {
      rota: null,
      refusal: {
        at,
        text: error instanceof ApiError ? error.message : 'Не получилось, попробуй ещё раз',
      },
      settled: false,
    };
  }
}
